module.exports = __webpack_public_path__ + "media/images/smart_phone/order_menu_confirm/btn_my-order-2-64067193d5c05e9a3bd74db2d03c871b.png";